import { Button, style } from '@do/walrus';
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { ButtonImage, ButtonImageBg, ButtonProps } from '../Common';
import newBrandDesignVars from './overwrite-vars.scss';

const CustomButton = styled(Button)`
  margin-top: ${style.vars.whitespace.regular};
  border: ${style.vars.borderWidth.thin} solid ${newBrandDesignVars.grey6};
  border-radius: ${newBrandDesignVars.border_radius_xlarge};
  color: ${newBrandDesignVars.grey3};
`;

interface OauthButtonProps extends ButtonProps {
  iconSrc: string;
}

const OauthButton = ({
  text,
  onClick,
  disabled = false,
  iconSrc
}: OauthButtonProps): ReactElement => {
  return (
    <CustomButton
      fullWidth
      variation="secondary"
      onClick={onClick}
      disabled={disabled}
    >
      <ButtonImageBg>
        <ButtonImage src={iconSrc} />
      </ButtonImageBg>
      {text}
    </CustomButton>
  );
};

export default OauthButton;
